module.exports = __webpack_public_path__ + "media/images/fancybox/fancybox_loading@2x-d8f0a9727c7b19e2f0dbb378910ef028.gif";